function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNewsletter = function SvgNewsletter(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3262"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 608",
    d: "M508 517.476v6.432a1.577 1.577 0 0 1-.206.781l-5.611-4.156 5.468-4.049a1.582 1.582 0 0 1 .349.992z",
    style: {
      fill: "#838383"
    },
    transform: "translate(-492 -512.889)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 609",
    d: "M507.237 525.264a1.576 1.576 0 0 1-.825.232h-12.824a1.576 1.576 0 0 1-.825-.232l5.722-4.237.641.475a1.54 1.54 0 0 0 1.748 0l.641-.475z",
    style: {
      fill: "#838383"
    },
    transform: "translate(-492 -512.889)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 610",
    d: "m497.817 520.533-5.611 4.156a1.577 1.577 0 0 1-.206-.781v-6.432a1.582 1.582 0 0 1 .349-.992z",
    style: {
      fill: "#838383"
    },
    transform: "translate(-492 -512.889)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 611",
    d: "m506.979 515.993-5.464 4.046-.667.494-.446.33a.749.749 0 0 1-.8 0l-.446-.33-.667-.494-5.465-4.046a1.579 1.579 0 0 1 .568-.1h12.824a1.573 1.573 0 0 1 .563.1z",
    style: {
      fill: "#838383"
    },
    transform: "translate(-492 -512.889)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2171",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewsletter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/newsletter.f3ea390b.svg";
export { ForwardRef as ReactComponent };